<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
        <div class="breadcrumb">
            <ul class="m-0">
                <li>
                    <router-link to="/app/resources">Resources</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'DetailResource', params: {code: slug } }">{{ form.title }}</router-link>
                </li>
                <li class="active">
                    Update
                </li>
            </ul>
        </div>
    </div>
    <div class="max-w-5xl m-auto shadow-md rounded-md bg-white mt-5">
        <form @submit.prevent="actionSubmit()">
            <div class="text-center border-b py-4">
                <h3 class="font-bold text-lg"> Update Resources </h3>
            </div>
            <div class="p-7 space-y-5">
                <input class="form-control" v-model="form.id" type="hidden" value="" autocomplete="off">
                <div>
                    <label class="font-semibold">Type</label>
                    <select v-model="form.type" class="form-control" required>
                        <option value="">Select Type</option>
                        <option value="eBooks">eBooks</option>
                        <option value="Journals">Journals</option>
                        <option value="Videos">Videos</option>
                        <option value="Podcast">Podcast</option>
                        <option value="Articles">Articles / Blog</option>
                        <option value="Documents">Documents</option>
                    </select>
                </div>
                <div>
                    <label class="font-semibold">Title</label><br>
                    <input class="form-control" v-model="form.title" type="text" value="" autocomplete="off" required>
                </div>
                <div>
                    <label class="font-semibold">Category</label>
                    <select v-model="form.category" class="form-control" required>
                        <option value="">Select Category</option>
                        <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.title }}</option>
                    </select>
                </div>
                <div v-if="form.type === 'eBooks' || form.type === 'Journals' || form.type === 'Articles' || form.type === 'Documents'">
                    <label class="font-semibold">Author</label><br>
                    <input class="form-control" v-model="form.author" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks' || form.type === 'Journals'">
                    <label class="font-semibold">Publisher</label><br>
                    <input class="form-control" v-model="form.publisher" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks'">
                    <label class="font-semibold">ISSN - ISBN</label><br>
                    <input class="form-control" v-model="form.isbn" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks' || form.type === 'Journals' || form.type === 'Documents'">
                    <label class="font-semibold">Publication Year</label><br>
                    <input class="form-control" v-model="form.publication_year" type="number" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Documents'">
                    <label class="font-semibold">Document Type</label><br>
                    <input class="form-control" v-model="form.document_type" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks'">
                    <label class="font-semibold">Language</label><br>
                    <input class="form-control" v-model="form.language" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Journals'">
                    <label class="font-semibold">Journal Volume / Number</label><br>
                    <input class="form-control" v-model="form.journal_volume" type="number" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks' || form.type === 'Journals'">
                    <label class="font-semibold">Number of Pages</label><br>
                    <input class="form-control" v-model="form.numb_of_page" type="number" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'eBooks'">
                    <label class="font-semibold">Translator (if needed)</label><br>
                    <input class="form-control" v-model="form.translator" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Videos' || form.type === 'Podcast'">
                    <label class="font-semibold">Creator</label><br>
                    <input class="form-control" v-model="form.creator" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Videos' || form.type === 'Podcast'">
                    <label class="font-semibold">Duration</label><br>
                    <input class="form-control" v-model="form.duration" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Videos' || form.type === 'Podcast' || form.type === 'Articles'">
                    <label class="font-semibold">Link</label><br>
                    <input class="form-control" v-model="form.link" type="text" value="" autocomplete="off">
                </div>
                <div v-if="form.type === 'Journals' || form.type === 'Videos' || form.type === 'Podcast' || form.type === 'Articles' || form.type === 'Documents'">
                    <label class="font-semibold">Description</label><br>
                    <Editor v-model="form.description" />
                </div>
                <div v-if="form.type === 'Articles'">
                    <label class="font-semibold">Content</label><br>
                    <Editor v-model="form.content" />
                </div>
                <div v-if="file && (form.type === 'Journals' || form.type === 'Documents') && file !== ''">
                    <label class="font-semibold">File</label><br>
                    <a :href="file" target="_blank">
                        <Icon icon="akar-icons:file" class="fs-30 d-inline" /> {{ file_name }}
                    </a>
                </div>
                <div v-if="form.type === 'Journals' || form.type === 'Documents'">
                    <label class="font-semibold">Change File</label><br>
                    <input type="file" @change="onFileSelected($event, 'file')" class="pt-2">
                </div>
                <div>
                    <label class="font-semibold">Preview</label><br>
                    <div class="image-uploader">
                        <input type="file" ref="preview" @change="onImageSelected($event, 'preview')">
                        <span @click="$refs.preview.click()"><Icon icon="bi:cloud-upload" /></span>
                        <img :src="preview ? preview : $placeholder2" alt="Preview" class="w-80">
                    </div>
                </div>
                <div>
                    <label class="font-semibold">Status</label>
                    <select v-model="form.status" class="form-control" required>
                        <option value="">Select Status</option>
                        <option value="public">Public</option>
                        <option value="private">Private</option>
                    </select>
                </div>
                <div>
                    <label class="font-semibold">Tags</label><br>
                    <vue-tags-input v-model="tags" :tags="form.tags" @tags-changed="newTags => form.tags = newTags" class="form-control" />
                </div>
            </div>
            <!-- form footer -->
            <div class="border-t flex justify-center border-gray-100 p-6">
                <button class="lg:w-1/3 h-9 lg:px-5 rounded-md bg-blue-600 text-white space-x-1.5 px-5" :class="disable_submit">
                    <span v-if="disable_submit == ''">Update Now</span>
                    <b-spinner v-if="disable_submit == 'disabled'" label="Loading..." small />
                </button>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import { Icon } from '@iconify/vue2'
    import Editor from '@/components/Editor'
    import VueTagsInput from '@johmun/vue-tags-input'

    export default {
        name: 'update_resource',
        components: {
            Icon,
            Editor,
            VueTagsInput
        },
        data () {
            return {
                tags: '',
                categories: [],
                form: {
                    id: 0,
                    title: '',
                    link: '',
                    tags: [],
                    description: '',
                    category: '',
                    preview: '',
                    type: '',
                    author: '',
                    publisher: '',
                    isbn: '',
                    publication_year: '',
                    language: '',
                    numb_of_page: '',
                    translator: '',
                    journal_volume: '',
                    category_text: '',
                    file: '',
                    creator: '',
                    duration: '',
                    content: '',
                    status: '',
                    document_type: ''
                },
                preview: '',
                file: '',
                file_name: '',
                slug: '',
                disable_submit: ''
            }
        },
        async created () {
            try {
                const result = await axios.get('category?type=resource')
                this.categories = result.data.result
                const res = await axios.get('resource/' + this.$route.params.code)
                this.form.id = res.data.result.id
                this.form.title = res.data.result.title
                this.form.link = res.data.result.link
                this.form.description = res.data.result.description
                this.form.category = res.data.result.category.id
                this.form.type = res.data.result.type
                this.form.author = res.data.result.author
                this.form.publisher = res.data.result.publisher
                this.form.isbn = res.data.result.isbn
                this.form.publication_year = res.data.result.publication_year
                this.form.language = res.data.result.language
                this.form.numb_of_page = res.data.result.numb_of_page
                this.form.translator = res.data.result.translator
                this.form.journal_volume = res.data.result.journal_volume
                this.form.category_text = res.data.result.category_text
                this.form.creator = res.data.result.creator
                this.form.duration = res.data.result.duration
                this.form.content = res.data.result.content
                this.form.status = res.data.result.status
                this.form.document_type = res.data.result.document_type

                this.preview = res.data.result.images
                this.slug = res.data.result.slug
                this.file = res.data.result.file
                this.file_name = res.data.result.file_name

                if (res.data.result.tags !== '') {
                    const tags = res.data.result.tags.split(',')
                    for (let index = 0; index < tags.length; index++) {
                        this.form.tags.push({ text: tags[index] })
                    }
                }
            } catch (e) {
                console.error(e)
            }
        },
        methods: {
            actionSubmit () {
                this.disable_submit = 'disabled'
                const $this = this
                const formData = new FormData()
                Object.keys(this.form).forEach(e => {
                    if (e === 'tags') {
                        formData.append(e, JSON.stringify(this.form[e]))
                    } else {
                        formData.append(e, this.form[e])
                    }
                })
                axios.post('resource/update', formData).then(function (response) {
                    $this.disable_submit = ''
                    $this.$swal({
                        imageUrl: require('@/assets/images/vector-success.png'),
                        imageWidth: 400,
                        title: 'Berhasil Update Resource',
                        text: response.data.message
                    }).then(() => {
                        $this.$router.push({ name: 'DetailResource', params: { code: $this.slug } })
                    })
                }).catch(function () {
                    $this.disable_submit = ''
                    $this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something Wrong'
                    })
                })
            },
            onImageSelected (e, target) {
                this.form[target] = e.target.files[0]
                this[target] = URL.createObjectURL(this.form[target])
            },
            onFileSelected (e, target) {
                this.form[target] = e.target.files[0]
            }
        }
    }
</script>
